import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Section, SectionTitle } from "../Section";
import { RecentSearchesCard } from "./RecentSearchesCard";
import styles from "./RecentSearchesSection.module.scss";
import { useRecentSearchNavigation } from "./useRecentSearchNavigation";
import { useShowCarsSearch } from "@/hooks/useShowCarsSearch";
import { useRecentSearches } from "@/utils/useRecentSearches";

export const RecentSearchesSection = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "RecentSearchesSection");

  const showCarsSearch = useShowCarsSearch();

  const { recentSearches } = useRecentSearches();

  const filteredSearches = showCarsSearch
    ? recentSearches
    : recentSearches.filter((s) => s.type !== "car");

  const onSelectSearch = useRecentSearchNavigation();

  if (filteredSearches.length === 0) {
    return null;
  }
  const searches = filteredSearches.slice(0, 2);
  return (
    <Section className={block}>
      <SectionTitle as="h1" className={cn("title")}>
        {t("home.recentSearches.title")}
      </SectionTitle>
      <div className={cn("list")}>
        {searches.map((search, index) => (
          <RecentSearchesCard
            search={search}
            onSelectSearch={onSelectSearch}
            key={index}
          />
        ))}
      </div>
    </Section>
  );
};
